import { render } from "./LeaseCategory.vue?vue&type=template&id=8dbe681e&scoped=true"
import script from "./LeaseCategory.vue?vue&type=script&lang=ts"
export * from "./LeaseCategory.vue?vue&type=script&lang=ts"

import "./LeaseCategory.vue?vue&type=style&index=0&id=8dbe681e&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-8dbe681e"

export default script